<div class="certificate-detail-page">
  @if (detail(); as item) {
    <section class="certificate-detail-hero">
      <div class="certificate-detail-copy">
        <span class="kicker">DriveMe Academy Nachweis</span>
        <h1>{{ item.course.title }}</h1>
        <p>{{ item.certificateNumber }} · Teilnahmebestätigung für {{ item.driver.displayName }}</p>

        <div class="certificate-hero-meta">
          <span>{{ item.course.moduleNumber }}. Modul</span>
          <span>{{ formatScore(item.scorePercent) }}</span>
          <span>{{ item.validUntil ? 'gültig bis ' + formatDate(item.validUntil) : 'ohne Ablaufdatum' }}</span>
        </div>
      </div>

      <span class="status-pill" [class.success]="item.valid" [class.danger]="!item.valid">
        {{ item.valid ? 'gültig' : statusLabel(item.status) }}
      </span>
    </section>

    @if (notice()) {
      <p class="info-message">{{ notice() }}</p>
    }

    <section class="certificate-stat-grid">
      <article class="certificate-stat-card">
        <span>Zertifikatsnummer</span>
        <strong>{{ item.certificateNumber }}</strong>
        <small>Öffentlich prüfbar über den Nachweis-Link</small>
      </article>

      <article class="certificate-stat-card accent">
        <span>Bewertung</span>
        <strong>{{ formatScore(item.scorePercent) }}</strong>
        <small>Ergebnis aus dem Wissens-Check</small>
      </article>

      <article class="certificate-stat-card">
        <span>Ausgestellt</span>
        <strong>{{ formatDateTime(item.issuedAt) }}</strong>
        <small>Erstellungszeitpunkt des Zertifikats</small>
      </article>

      <article class="certificate-stat-card" [class.success]="item.valid" [class.danger]="!item.valid">
        <span>Status</span>
        <strong>{{ item.valid ? 'gültig' : statusLabel(item.status) }}</strong>
        <small>{{ item.pdfAvailable ? 'PDF liegt vor' : 'PDF wird bei Bedarf erzeugt' }}</small>
      </article>
    </section>

    <section class="certificate-detail-grid">
      <section class="panel">
        <div class="panel-heading">
          <div>
            <h2>Teilnehmer</h2>
            <p>Person und Betrieb, für den der Nachweis ausgestellt wurde.</p>
          </div>
        </div>

        <div class="detail-grid">
          <div><span>Name</span><strong>{{ item.driver.displayName }}</strong></div>
          <div><span>E-Mail</span><strong>{{ item.driver.email }}</strong></div>
          <div><span>Betrieb</span><strong>{{ item.driver.companyName }}</strong></div>
          <div><span>Zentrale</span><strong>{{ item.driver.organizationName }}</strong></div>
          <div><span>Fahrernummer</span><strong>{{ valueOrDash(item.driver.personnelNumber) }}</strong></div>
          <div><span>Telefon</span><strong>{{ valueOrDash(item.driver.phone) }}</strong></div>
        </div>
      </section>

      <section class="panel">
        <div class="panel-heading">
          <div>
            <h2>Nachweis</h2>
            <p>Ausstellung, Gültigkeit und öffentliche Prüfung.</p>
          </div>
        </div>

        <div class="detail-grid">
          <div><span>Ausgestellt am</span><strong>{{ formatDateTime(item.issuedAt) }}</strong></div>
          <div><span>Gültig bis</span><strong>{{ item.validUntil ? formatDate(item.validUntil) : '-' }}</strong></div>
          <div><span>Ergebnis</span><strong>{{ formatScore(item.scorePercent) }}</strong></div>
          <div><span>Status</span><strong>{{ statusLabel(item.status) }}</strong></div>
          <div><span>Prüfpfad</span><strong>{{ item.publicVerifyPath }}</strong></div>
          <div><span>PDF-Datei</span><strong>{{ item.pdfFileName }}</strong></div>
        </div>
      </section>
    </section>

    <section class="panel section-stack">
      <div class="panel-heading">
        <div>
          <h2>PDF-Download</h2>
          <p>Der Nachweis kann als PDF heruntergeladen werden.</p>
        </div>
      </div>

      <div class="action-row certificate-action-row">
        <button type="button" class="primary-button" (click)="downloadPdf(item)" [disabled]="downloading()">
          {{ downloading() ? 'Wird heruntergeladen...' : 'PDF herunterladen' }}
        </button>
        @if (management()) {
          <a class="ghost-button as-link" [routerLink]="['/drivers', item.driver.id]">Zur Fahrerakte</a>
        } @else {
          <a class="ghost-button as-link" routerLink="/learning">Zum Lernbereich</a>
        }
        <a class="ghost-button as-link" routerLink="/certificates">Zur Zertifikatsübersicht</a>
      </div>

      <div class="data-grid compact">
        <span>Öffentliche URL</span>
        <strong>{{ item.publicVerifyUrl }}</strong>
        <span>PDF vorhanden</span>
        <strong>{{ item.pdfAvailable ? 'Ja' : 'Wird bei Bedarf erzeugt' }}</strong>
        <span>Widerrufen am</span>
        <strong>{{ item.revokedAt ? formatDateTime(item.revokedAt) : '-' }}</strong>
        <span>Widerrufsgrund</span>
        <strong>{{ valueOrDash(item.revokedReason) }}</strong>
      </div>
    </section>
  } @else {
    <div class="empty">Zertifikat wird geladen.</div>
  }
</div>
